<template>
  <section class="d-flex align-items-center" id="wrap">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <h1 class="circle">1</h1>
          <h2>Insert your Identity Card in the reader</h2>
        </div>
        <div class="col-12" id="steps"><img class="img-fluid" src="../assets/img/Paso2.png"></div>
      </div>
    </div>
  </section>
</template>

<script>
import {hub} from '../assets/js/iSCertHub';

export default {
  name: "StepOne",
  created() {
    let value = {"operation": "WAIT_FOR_INSERT"}
    let param = JSON.stringify(value)
    console.log("{}")
    console.log(param);
    console.log(hub)
    hub.caller("nid-reader")
        .value(param)
        .onFail(() =>{
          alert("Error connecting to middleware. Are you sure it is installed?");
        })
        .call((obj) =>{
          console.log(obj)
          console.log(JSON.stringify(obj,null,4))
          if(obj.success===true) {
            this.$emit('nextStep', 'WaitForData')
          } else{
            this.$emit('data',obj)
            this.$emit('nextStep','StepError')
          }
        })
  },
  emits: ['nextStep','data'],
  props:{
    data: {}
  },


}


</script>

<style scoped>

</style>